<template>
  <div id="emergency-detail">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <span class="title">应急保障</span>
        <span class="tip"> — 订单确认</span>
        <span class="right" v-show="!isSign" @click="goBackClick">返回上一步 ></span>
      </div>
      <div class="section section2 sectionInfo">
        <div class="title">服务信息</div>
        <div class="row">
          <span class="tip">联系人：</span>
          <span class="value">{{planInfo.user_name}}</span>
        </div>
        <div class="row">
          <span class="tip">手机号：</span>
          <span class="value">{{planInfo.phone}}</span>
        </div>
        <div class="row">
          <span class="tip">项目地址：</span>
          <span class="value">{{planInfo.province + ' ' + planInfo.city + ' ' + planInfo.area}}</span>
        </div>
        <div class="row">
          <span class="tip">详细地址：</span>
          <span class="value address">{{planInfo.address_detail}}</span>
        </div>
      </div>
      <div class="section section3 sectionInfo">
        <div class="title">需求信息</div>
        <div class="row">
          <span class="tip">场所选择：</span>
          <span class="value">{{planInfo.place}}</span>
        </div>
        <div class="row">
          <span class="tip">需求选择：</span>
          <span class="value" v-show="planInfo.demand.length > 0">{{planInfo.demand}}</span>
          <span class="value" v-show="planInfo.demand.length <= 0">-</span>
        </div>
        <div class="row">
          <span class="tip">客户属性：</span>
          <span class="value" v-show="planInfo.customer_property.length > 0">{{planInfo.customer_property}}</span>
          <span class="value" v-show="planInfo.customer_property.length <= 0">-</span>
        </div>
        <div class="row">
          <span class="tip">租赁需求：</span>
          <span class="value">{{planInfo.lease_types}}</span>
        </div>
        <div class="row" v-show="isSecurity">
          <span class="tip">安保类型：</span>
          <span class="value">{{security_type_str}}</span>
        </div>
        <div class="row" v-show="isSecurity">
          <span class="tip">需求周期：</span>
          <span class="value">{{planInfo.security_demand_start + ' 至 ' + planInfo.security_demand_end + '&nbsp;&nbsp;共' + securityDay + '天'}}
            <br/><span v-show="planInfo.across_day">（工作节点{{endTimeStr}}{{planInfo.work_time_end}}:00）</span></span>
        </div>
        <div class="row" v-show="isSecurity">
          <span class="tip">工作时间：</span>
          <span class="value">{{planInfo.work_time_start + ':00 - ' + planInfo.work_time_end + ':00'}}</span>
        </div>
        <div class="row" v-show="isSecurity">
         <span class="tip">安保人数：</span>
          <span class="value">{{planInfo.security_guard_num + '位/班'}}&nbsp;&nbsp;<span>{{security_type_str}}共{{planInfo.security_guard_num_count + '位/天'}}</span></span>
        </div>
        <div class="row" v-show="isCar">
          <span class="tip">消防车租赁：</span>
          <span class="value">{{planInfo.car_rental_num + '辆'}}</span>
        </div>
        <div class="row" v-show="isCar">
          <span class="tip">需求周期：</span>
          <span class="value">{{planInfo.car_rental_start + ' 至 ' + planInfo.car_rental_end + '&nbsp;&nbsp;共' + carDay + '天'}}</span>
        </div>
      </div>
      <div class="section section4 sectionInfo">
        <div class="title">合同签署</div>
        <div class="c-type"  v-show="!isSign">
          <div class="online" @click="contractTypeClick(0)"><div class="image" :class="{'defaultImage': !isOnline,'selImage': isOnline}" ></div><div class="tip">线上签署</div></div>
          <div class="offline" @click="contractTypeClick(1)"><div class="image" :class="{'defaultImage': !isOffline,'selImage': isOffline}" ></div><div class="tip">线下签署</div></div>
        </div>
        <div v-show="isOffline||isSign" class="c-typeInfo">
          <div class="c-image">
            <img class="image1" src="../assets/icon-contract.png">
            <img class="image2" v-show="isSign" src="../assets/icon-contract-s.png">
            <div class="preview" @click="preClick">预览合同</div>
          </div>
          <div class="c-warn" v-show="!isSign">
            <div class="ctitle">注意事项：</div>
            <div class="ctip">１.请下载并查阅购买合同，需盖<span class="red">乙方企业公章和乙方法定代表人签字</span>为准。
              <br/><span class="nor">甲方邮寄地址：</span>上海市黄浦区淮海中路98号金钟广场33层
              <br/><span class="nor">部门：</span>法务部  400-1919-119
              <br/><span class="nor">邮编：</span>200021</div>
          </div>
        </div>
      </div>
      <div class="section section5">
        <div class="row2" v-show="isSecurity">
          <div class="tip">安保费：</div>
          <div class="value">￥{{planInfo.security_money * 0.01 + '.00'}}元</div>
        </div>
        <div class="row2" v-show="isCar">
          <div class="tip">消防车租赁费：</div>
          <div class="value">￥{{planInfo.car_rental_money * 0.01 + '.00'}}元</div>
        </div>
<!--        <div class="row2" v-show="isCar">-->
<!--          <div class="tip"> 消防车配送费：</div>-->
<!--          <div class="value">￥{{planInfo.car_dispatching_money * 0.01 + '.00'}}元</div>-->
<!--        </div>-->
      </div>
      <div class="section6">
        <div class="money"><span class="tip1">方案总价：</span><span class="tip2">￥</span>{{(planInfo.security_money * 0.01 + planInfo.car_rental_money * 0.01) + '.00'}}</div>
        <div class="submit" @click='submitClick'>{{payTitle}}</div>
      </div>
      <!--  支付弹窗  -->
      <payView :type="(isSign===true)?'5':'4'" :show="payViewVisible" :orderId="orderDate.orderId" :payInfo="payInfo" :money="payMoney" @payValue="payValue"></payView>
      <!--  支付成功弹窗  -->
      <SuccessView :show="showSuccessView" type="2" @successViewClick="successViewClick"></SuccessView>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import mainHeader from '../view/header'
import payView from '../components/pay'
import SuccessView from '../components/success-view'
export default {
  data () {
    return {
      payViewVisible: false,
      showSuccessView: false,
      planId: '',
      planInfo: {
        user_name: '',
        demand: '',
        customer_property: ''
      },
      isOnline: 1,
      isOffline: 0,
      security_type_str: '',
      isSecurity: 0, // 有安保人员
      isCar: 0, // 有消防车租赁
      securityDay: 1,
      carDay: 1,
      endTimeStr: '', // 工作节点
      payInfo: {
        consultingId: 0,
        contractOnLine: 0 // 0 线下 1 线上
      },
      orderState: 0, // 是否 下单 1 已下单
      orderDate: {}, // 订单状态
      payTitle: '确认下单',
      payMoney: '',
      isSign: false, // 是否 已签署
      personList: [] // 经办人列表
    }
  },
  methods: {
    logoutClick: function () {
      this.$router.push({path: 'home'})
    },
    goBackClick: function () {
      this.$router.go(-1)
    },
    contractTypeClick: function (index) {
      if (index === 0) {
        this.isOnline = 1
        this.isOffline = 0
      }
      if (index === 1) {
        this.isOnline = 0
        this.isOffline = 1
      }

      this.payInfo.contractOnLine = this.isOnline
    },
    preClick: function () {
      if (parseInt(localStorage.getItem('isApp')) === 1 && this.utils.isIphone()) { // ios app 内嵌网页 查看合同
        if (this.isSign === true) {
          window.webkit.messageHandlers.contractLook.postMessage({'planId': this.planId, 'real': 1})
        } else {
          this.$router.push({path: 'checkpdf', query: {planId: this.planId, real: 0}})
        }
      } else {
        if (this.isSign === true) {
          this.$router.push({path: 'checkpdf', query: {planId: this.planId, real: 1}})
        } else {
          this.$router.push({path: 'checkpdf', query: {planId: this.planId, real: 0}})
        }
      }
    },
    loadData: function () {
      this.planId = this.$route.query.planId
      this.payInfo.consultingId = this.planId

      this.loadState(0)
      var _this = this
      // 单子详情
      this.utils.GET(this.accountUrl + '/solutionsConsulting/consultingOrderMoneyInfo?id=' + this.planId, function (response) {
        if (response.code === 0) {
          _this.planInfo = response.data
          _this.isSecurity = 0
          _this.isCar = 0
          if (_this.planInfo.lease_types.indexOf('安保人员') >= 0) {
            _this.isSecurity = 1
          }
          if (_this.planInfo.lease_types.indexOf('消防车租赁') >= 0) {
            _this.isCar = 1
          }
          if (_this.planInfo.security_type === 1) {
            _this.security_type_str = '单班保障'
          }
          if (_this.planInfo.security_type === 2) {
            _this.security_type_str = '双班保障'
          }
          if (_this.planInfo.security_type === 3) {
            _this.security_type_str = '三班保障'
          }
          console.log('=======0000000000000000')
          if (_this.isSecurity === 1) {
            var date1 = new Date(_this.planInfo.security_demand_start.replace(/-/g, '/'))
            var date2 = new Date(_this.planInfo.security_demand_end.replace(/-/g, '/'))
            _this.securityDay = parseInt((date2.getTime() - date1.getTime()) / (24 * 60 * 60 * 1000)) + 1
            if (_this.planInfo.across_day === 1) {
              let endDate = new Date(date2.getTime() + 1 * 86400000)
              _this.endTimeStr = (parseInt(endDate.getMonth()) + 1).toString() + '月' + (parseInt(endDate.getDate())).toString() + '日'
            }
          }
          if (_this.isCar === 1) {
            var date3 = new Date(_this.planInfo.car_rental_start.replace(/-/g, '/'))
            var date4 = new Date(_this.planInfo.car_rental_end.replace(/-/g, '/'))
            _this.carDay = parseInt((date4.getTime() - date3.getTime()) / (24 * 60 * 60 * 1000)) + 1
          }
        }
      })

      // 获取 经办人列表
      this.utils.GET(this.accountUrl + '/ESign/personList', function (response) {
        _this.personList = response.data
      })
    },
    loadState: function (type) {
      var _this = this
      // 获取单子状态  是否下单
      this.utils.GET(this.accountUrl + '/zxOrder/consultingOrderStatus?sId=' + this.planId, function (response) {
        _this.orderDate = response.data
        _this.orderState = parseInt(_this.orderDate.orderState)
        _this.orderStateClick(type)
      })
    },
    orderStateClick: function (click) { // 是否 点击下一步
      console.log('=======11111111111===========')
      // 已下单 清除 本地缓存
      // -1说明此id的方案咨询记录不存在 0未生成订单 1订单已生成
      if (this.orderState === 1) {
        localStorage.removeItem('planInfo')
        if (this.orderDate.check_status === '未选择') {
          if (click === 1) {
            if (this.personList.length <= 0) { // 跳转 添加经办人
              this.$router.push({path: 'company-auth', query: {planId: this.planId}})
            } else { // 跳转 选择经办人
              this.$router.push({path: 'company-person', query: {planId: this.planId}})
            }
          }
        } else {
          if ((this.orderDate.contract_online_status === '待实名' && this.orderDate.check_status === '已选择') ||
            this.orderDate.contract_online_status === '待认证' ||
            this.orderDate.contract_online_status === '待授权') {
            if (click === 1) {
              this.$router.push({path: 'company-auth', query: {planId: this.planId}})
            }
          }
          if (this.orderDate.contract_online_status === '待签署') {
            // contract_status  合同签署参考字段  // 跳转 签署合同
            if (click === 1) {
              if (parseInt(localStorage.getItem('isApp')) === 1 && this.utils.isIphone()) { // ios app 内嵌网页 签署合同
                window.webkit.messageHandlers.contractSign.postMessage({'planId': this.planId})
              } else {
                this.$router.push({path: 'auth-online', query: {planId: this.planId}})
              }
              // 签署合同 新窗口打开
              // let routeData = this.$router.resolve({path: '/auth-online', query: {planId: this.planId}})
              // window.open(routeData.href, '_blank')
            }
          }
        }
        if (this.orderDate.contract_online_status === '签署完成') {
          // 已签署状态
          this.isSign = true
          this.isOnline = 1
          this.payTitle = '在线支付'
        }
      }
    },
    submitClick: function () {
      var _this = this
      this.payMoney = (this.planInfo.security_money * 0.01 + this.planInfo.car_rental_money * 0.01) + '.00'
      if (this.isOnline === 0) { // 线下先 下单，付款
        this.payViewVisible = true
      }
      if (this.isOnline === 1) { // 线上先 下单，签署合同
        if (this.isSign === true) { // 线上 签署合同完成 发起支付
          this.payViewVisible = true
          return
        }
        if (this.planInfo.contract_on_line !== this.isOnline) {
          console.log('重现下单======================')
          let url = this.accountUrl + '/zxOrder/submitConsultingOrder?consultingId=' +
            this.planId + '&contractOnLine=' + this.isOnline
          console.log('===========' + url)
          this.utils.POST(url, null, function (response) {
            // 下单
            _this.loadState(1)
          })
        } else {
          _this.loadState(1)
        }
      }
    },
    payValue: function (state) {
      this.payViewVisible = false
      console.log('============支付回调')
      if (state === 1) { // 支付成功 跳转 支付成功界面
        this.showSuccessView = true
      }
    },
    successViewClick: function () {
      this.showSuccessView = false
      this.$router.push({path: 'emergency-support'})
    }
  },
  components: {
    mainHeader,
    payView,
    SuccessView
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再咨询！')
        _this.$router.push({path: 'login', query: {back: 1}})
      } else {
        _this.loadData()
      }
    })
  }
}
</script>

<style scoped>
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #F1F1F1;
    margin-top: 55px;
  }
  .section{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;
  }
  .section1{
    height: 60px;
    box-sizing: border-box;
    border-bottom: #F1F1F1 solid 10px;
  }
  .section1 .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section1 .tip{
     height: 50px;
     line-height: 50px;
     color: #000;
     font-size: 13px;
     font-weight: bold;
     margin-left: 5px;
   }
  .section1 .right{
    position: absolute;
    right: 15px;
    height: 50px;
    line-height: 50px;
    color: #999999;
    font-size: 13px;
    font-weight: bold;
  }
  .section2{
    position: relative;
    height: 240px;
  }
  .sectionInfo .title{
    position: relative;
    top: 5px;
    margin-left: 15px;
    height: 50px;
    line-height: 50px;
    color: #000000;
    font-size: 15px;
    font-weight: bold;
  }
  .sectionInfo .row{
    position: relative;
    margin-top: 10px;
    width: 100%;
    min-height: 25px;
  }
  .sectionInfo .row .tip{
    position: absolute;
    top: 0px;
    left: 15px;
    color: #808080;
    font-size: 14px;
    height: 25px;
    line-height: 25px;
    width: 90px;
    /*background-color: yellow;*/
  }
  .sectionInfo .row .value{
    position: relative;
    top: 0px;
    left: 110px;
    /*right: 15px;*/
    /*margin-right: 15px;*/
    /*width: calc(100% - 125px);*/
    color: #333333;
    font-size: 14px;
    min-height: 25px;
    line-height: 25px;
    /*background-color: yellow;*/
  }
  .sectionInfo .row .address{
    display:block;
    top: 2px;
    height: 60px;
    line-height: 20px;
    /*overflow: hidden;*/
    word-break:normal;
    width: calc(100% - 125px);
    white-space:pre-wrap;
    word-wrap : break-word ;
    overflow: hidden ;
  }
  .section3{
    margin-top: 10px;
    position: relative;
    min-height: 280px;
    padding-bottom: 20px;
  }
  .section4{
    margin-top: 10px;
    position: relative;
    /*height: 260px;*/
    min-height: 110px;
  }
  .section5{
    position: relative;
    padding: 15px;
    margin-top: 10px;
    min-height: 50px;
    margin-bottom: 70px;
  }
  .c-type{
    position: relative;
    margin-top: 10px;
    height: 20px;
    /*background-color: yellow;*/
  }
  .c-type .online{
    position: absolute;
    left: 15px;
  }
  .c-type .offline{
    position: absolute;
    left: 130px;
  }
  .c-type .image{
    position: relative;
    top: 0px;
    margin-left: 0px;
    width: 20px;
    height: 20px;
  }
  .c-type .tip{
    position: relative;
    top: -20px;
    margin-left: 30px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #333333;
  }
  .defaultImage{
    background-image: url("../assets/radio_n.png");
    background-size: cover;
    background-position: center center;
  }
  .selImage{
    background-image: url("../assets/radio_s.png");
    background-size: cover;
    background-position: center center;
  }
  .c-typeInfo{
    position: relative;
    margin-top: 20px;
    height: 160px;
  }
  .c-image{
    position: absolute;
    top: 0px;
    left: 15px;
    width: 88px;
    height: 140px;
  }
  .c-image .image1{
    position: absolute;
    left: 0px;
    top: 0px;
    width: 88px;
    height: 110px;
  }
  .c-image .image2{
    position: absolute;
    left: 35px;
    top: -20px;
    width: 94px;
    height: 73px;
  }
  .c-image .preview{
    position: absolute;
    left: 0px;
    top: 110px;
    color: #FFFFFF;
    background-color: #c41335;
    width: 88px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
  }
  .c-warn{
    position: absolute;
    top: 0px;
    left: 117px;
    right: 15px;
    height: 140px;
  }
  .c-warn .ctitle{
    position: absolute;
    top: 0px;
    left: 0px;
    height: 20px;
    line-height: 20px;
    color: #333333;
    font-size: 12px;
    font-weight: bold;
  }
  .c-warn .ctip{
    position: absolute;
    top: 20px;
    left: 0px;
    line-height: 20px;
    color: #333333;
    font-size: 12px;
  }
  .c-warn .ctip .red{
    color: #c41335;
  }
  .c-warn .ctip .nor{
    color: #808080;
  }
  .section5 .row2{
    position: relative;
    width: 100%;
    height: 20px;
  }
  .section5 .row2 .tip{
    position: absolute;
    top: 0px;
    left: 0px;
    color: #333333;
    font-size: 13px;
    height: 20px;
    line-height: 20px;
  }
  .section5 .row2 .value{
    position: absolute;
    right: 0px;
    color: #c41335;
    font-size: 13px;
    height: 20px;
    line-height: 20px;
  }
  .section6{
    position: fixed;
    width: 100%;
    bottom: 0px;
    height: 65px;
    line-height: 65px;
    background-color: #FFFFFF;
    border-top: solid #EEEEEE 1px;
    box-sizing: border-box;
  }
  .section6 .submit {
    position: absolute;
    top: 10px;
    right: 15px;
    height: 45px;
    line-height: 45px;
    width: 100px;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    background-color: #C41335;
    border-radius: 4px;
  }
  .section6 .money{
    position: absolute;
    top: 10px;
    right: 130px;
    height: 45px;
    line-height: 45px;
    color: #c41335;
    font-size: 17px;
    font-weight: bold;
  }
  .section6 .money .tip1{
    color: #333333;
    font-size: 12px;
    font-weight: normal;
  }
  .section6 .money .tip2{
    color: #c41335;
    font-size: 12px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/view/emergency-plan-detail.vue